<template>
  <a-card :bordered="false">

        <div class="table-page-search-wrapper">
            <a-row>
              <a-col :md="2" :sm="24">
                <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd">Add</a-button>
              </a-col>
<!--              <a-col :md="2" :sm="24">-->
<!--                <a-button style="margin-bottom: 10px" type="primary" @click="handleConfigAdd">Add config</a-button>-->
<!--              </a-col>-->
<!--              <a-col :md="2" :sm="24">-->
<!--                <a-button style="margin-bottom: 10px" type="primary" @click="editProdictConfig">Modify config</a-button>-->
<!--              </a-col>-->


            </a-row>
        </div>
        <div>
          <a-table
            ref="table"
            rowKey="id"
            size="middle"
            :columns="columns"
            :dataSource="dataSource"
            :loading="loading"
            bordered
          >
            <Dict slot="allowDiferTime" slot-scope="text" :dict-code="DICT_CODE.ALLOW_DIFER_TIME" :value="text"/>
             <template slot="allowPrepay" slot-scope="text">
              {{text==0?'Not Allowed':'Allowed'}}
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">Edit</a>
            </span>

          </a-table>
        </div>
         <prodict-item-modal ref="prodictItemModal" @ok="modalFormOk"></prodict-item-modal>
          <prodict-config-modal ref="ProdictConfigModal" @ok="modalFormOk"></prodict-config-modal>
          <prodict-config-list ref="ProdictConfigList"></prodict-config-list>
  </a-card>
</template>

<script>
import { getProductItemList } from '@/webpublicapi/operation'
import Dict from '../modules/Dict'
import ProdictItemModal from './modules/ProdictItemModal'
import ProdictConfigModal from './modules/ProdictConfigModal'
import ProdictConfigList from './modules/ProdictConfigList'
export default {
  name: 'productItemList',
  components: { Dict,ProdictItemModal,ProdictConfigModal,ProdictConfigList},
  props: {
    id:{
        type: [String, Number],
        default: undefined,
    },
   appSsid:{
        type: [String, Number],
        default: undefined,
    },
  },
  data () {
    return {
      dataSource: [],
      loading: false,
      columns: [
        {
          title: 'Term',
          align: 'center',
          dataIndex: 'duration'
        },
        {
          title: 'MostBigAmount',
          align: 'center',
          dataIndex: 'maxAmount'
        },
        {
          title: 'MostSmallAmount',
          align: 'center',
          dataIndex: 'minAmount'
        },
        {
          title: 'Disbursement Increment Amount',
          align: 'center',
          dataIndex: 'incrAmount'
        },
        {
          title: 'Extension Quota',
          align: 'center',
          dataIndex: 'incrQuota'
        },
        {
          title: 'Allow Extension Time',
          align: 'center',
          dataIndex: 'allowDiferTime',
          scopedSlots: { customRender: 'allowDiferTime' }
        },
         {
          title: 'Allow Pre-repayment',
          align: 'center',
          dataIndex: 'allowPrepay',
           scopedSlots: { customRender: 'allowPrepay' }
        },
         {
          title: 'Service Fee Rate',
          align: 'center',
          dataIndex: 'serviceFeeRate'
        },
         {
          title: 'Extension Service Fee',
          align: 'center',
          dataIndex: 'diferFeeRate'
        },
         {
          title: 'Overdue Fee Rate',
          align: 'center',
          dataIndex: 'overdueRate'
        },
        {
          title: 'Daily Interest Rate',
          align: 'center',
          dataIndex: 'dayInterestRate'
        },
        {
          title: 'Tax (Google Account No.)',
          align: 'center',
          dataIndex: 'ivaFee'
        },
        {
          title: 'Status',
          align: 'center',
          dataIndex: 'status',
          customRender: function (text) {
            if (text==='0') {
              return "Invalid"
            } else if (text==='1') {
              return "Valid"
            } else {
              return "";
            }
          }
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      title: 'Action',
      visible: false,
      screenWidth: 1200,
      model: {},
      proId: '',
    }
  },
  created () {
    this.proId = this.id;
    this.loadData()
  },
  methods: {
    loadData () {
       this.loading = true
       getProductItemList(Object.assign({productId:this.proId})).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data
        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },


    handleAdd () {
      this.$refs.prodictItemModal.add(this.proId,this.appSsid)
      this.$refs.prodictItemModal.title = 'Add'
    },
    handleEdit (record) {
      record.allowDiferTime = record.allowDiferTime != undefined && '' + record.allowDiferTime;
      this.$refs.prodictItemModal.edit(record)
      this.$refs.prodictItemModal.title = 'Edit'
    },
     handleConfigAdd () {
      this.$refs.ProdictConfigModal.add(this.proId,this.appSsid)
      this.$refs.ProdictConfigModal.title = 'AddConfiguration'
    },
    // Edit dictionary data
    editProdictConfig () {
     this.$refs.ProdictConfigList.edit(this.proId,this.appSsid)
      this.$refs.ProdictConfigList.title = 'AddConfiguration'
    },
    modalFormOk () {
      this.loadData()
    }
  },
  watch: {
    proId (val) {
      this.proId = val
    }
  }
}
</script>
<style scoped>

</style>
